module.exports = __webpack_public_path__ + "static/img/1.1c02366.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/1.png
// module id = TtBe
// module chunks = 0